
import {normalizeWorkforceProfile} from './normalizeWorkforceProfile';
import type {ApiWorkforceProfileRecord} from './workforceProfileApiTypes';
import {ApiSerializer} from '../../../../../serializers/ApiSerializer';
import type {PaginationObject} from '../../../../../types/shared-types';
import type {CompanyWorkforceProfile} from '../../types/WorkforceProfileTypes';

const emptyPagination: PaginationObject = {
  page: 1,
  perPage: 25,
  totalPages: 1,
  totalCount: 0,
  nextPage: null,
  previousPage: null,
};

export interface WorkforceProfilesPaginatedResponse {
  data: CompanyWorkforceProfile[];
  pagination: PaginationObject;
}

export const mapCompanyWorkforceProfilesResponse = (raw: unknown): WorkforceProfilesPaginatedResponse => {
  const body = ApiSerializer.toCamelCase(raw) as {
    companyWorkforceProfiles?: ApiWorkforceProfileRecord[];
    pagination?: PaginationObject;
  };

  const profiles = Array.isArray(body.companyWorkforceProfiles)
    ? body.companyWorkforceProfiles.map(normalizeWorkforceProfile)
    : [];

  return {
    data: profiles,
    pagination: body.pagination ? {...emptyPagination, ...body.pagination} : emptyPagination,
  };
};

export const mapWorkforceProfilesStatusResponse = (raw: unknown): CompanyWorkforceProfile[] => {
  const body = ApiSerializer.toCamelCase(raw) as {
    companyWorkforceProfiles?: ApiWorkforceProfileRecord[];
  };

  if (!Array.isArray(body.companyWorkforceProfiles)) {
    return [];
  }

  return body.companyWorkforceProfiles.map(normalizeWorkforceProfile);
};
